module.exports = __webpack_public_path__ + "static/media/Consolidated Audio Step-up Transformer.ef5b5b2a.png";